<template>
  <div>
    <button
      ref="toggle"
      class="inline-flex items-center p-0.5 text-sm font-medium text-center text-gray-500 hover:text-gray-800 rounded-lg focus:outline-none dark:text-gray-400 dark:hover:text-gray-100"
      type="button">
      <svg class="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z" />
      </svg>
    </button>

    <div
      ref="menu"
      class="hidden w-44 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600"
      style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate3d(1008px, 156px, 0px);"
      data-popper-placement="bottom">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeUnmount, onMounted } from 'vue'
import { Dropdown } from 'flowbite'

const dropdown = ref(null)
const toggle = ref(null)
const menu = ref(null)

const props = defineProps({
  placement: { type: String, default: 'right-start' }
})

onMounted(() => {
  if (toggle.value && menu.value) {
    dropdown.value = new Dropdown(
      menu.value,
      toggle.value,
      {
        placement: props.placement,
        triggerType: 'click',
        offsetSkidding: 0,
        offsetDistance: 10,
        delay: 300
      }
    )

    // Hack to close dropdown after menu item click.
    // eslint-disable-next-line no-underscore-dangle
    dropdown.value._targetEl.querySelectorAll('li').forEach((el) => {
      el.addEventListener('click', () => {
        dropdown.value.hide()
      })
    })
  }
})

onBeforeUnmount(() => {
  // eslint-disable-next-line no-underscore-dangle
  dropdown.value?._popperInstance.destroy()
})

</script>
